module.exports = "/_next/static/images/c26cb67c0e5392c0f7403433b1e3988d-ppf-lg.png";